export default "__VITE_ASSET__CbrhpEBZ__"